module.exports = __webpack_public_path__ + "css/ecube.48ec5942.css";